import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { CompanyAddressAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-company-address-audit-list',
  templateUrl: './company-address-audit-list.component.html',
  styleUrls: ['./company-address-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyAddressAuditListComponent implements OnInit {
  @Input() companyAddressId: number;
  @Input() loading: boolean;
  @Input() companyAddressAudits: CompanyAddressAudit[];

  @Output() loadCompanyAddress = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadCompanyAddress.emit(this.companyAddressId);
  }

  onNextPage() {
    this.nextPage.emit(this.companyAddressId);
  }
}
